var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-sm-flex"},[_c('div',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.name))]),_c('CheckboxInput',{staticClass:"ml-1",attrs:{"checked":_vm.value},on:{"value-change":_vm.changeValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }